(() => {
  const SLIDER_TAG = "oh-item-slider-component";

  function getStep(sliderEl) {
    const container = sliderEl.querySelector('[id^="Slider-"]');
    if (!container) return 1;

    const slides = Array.from(sliderEl.querySelectorAll('[id^="Slide-"]'))
      .filter((el) => el && el.clientWidth > 0);

    if (container.clientWidth <= 0 || slides.length < 2) return 1;

    const first = slides[0];
    const second = slides[1];
    const gap = Math.abs(second.offsetLeft - first.offsetLeft);

    if (!gap) return 1;

    const perView = Math.floor(container.clientWidth / gap);
    return Math.max(1, perView);
  }

  function resolveButtons(sliderEl) {
    const section = sliderEl.closest('[id^="shopify-section"]');

    const insidePrev = sliderEl.querySelector('button[name="previous"]');
    const insideNext = sliderEl.querySelector('button[name="next"]');

    const outsidePrevId = sliderEl.dataset.outsidePrevButtonId;
    const outsideNextId = sliderEl.dataset.outsideNextButtonId;

    const outsidePrev =
      outsidePrevId && section ? section.querySelector(`#${CSS.escape(outsidePrevId)}`) : null;
    const outsideNext =
      outsideNextId && section ? section.querySelector(`#${CSS.escape(outsideNextId)}`) : null;

    return {
      prev: outsidePrev || insidePrev,
      next: outsideNext || insideNext,
    };
  }

  function apply(sliderEl) {
    if (!sliderEl) return;

    const step = getStep(sliderEl);
    const { prev, next } = resolveButtons(sliderEl);

    if (prev) prev.dataset.step = String(step);
    if (next) next.dataset.step = String(step);
  }

  function applyAll() {
    document.querySelectorAll(SLIDER_TAG).forEach(apply);
  }

  // Run
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyAll, { once: true });
  } else {
    applyAll();
  }

  // Recalculate on resize
  window.addEventListener(
    "resize",
    () => {
      applyAll();
    },
    { passive: true }
  );

  // In case theme editor or app re-renders
  const mo = new MutationObserver(() => applyAll());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
